import { State, TableBlock } from "../../types";
import { blockIsTable } from "../../util";
import { isValidXml } from "../util";

export type UpdateCellTextAction = Readonly<{
  blockId: string;
  cellId: string;
  text: string;
  type: "UPDATE CELL TEXT";
}>;

export const updateCellText = (state: State, action: UpdateCellTextAction): State => {
  if (state.readonly) {
    return state;
  }
  if (!(action.blockId in state.blocks)) {
    return state;
  }
  const block = state.blocks[action.blockId];
  if (!blockIsTable(block)) {
    return state;
  }
  for (let i = 0; i < block.cells.length; i++) {
    for (let j = 0; j < block.cells[i].length; j++) {
      const cell = block.cells[i][j];
      if (cell.id !== action.cellId) {
        continue;
      }
      const newBlock: TableBlock = {
        ...block,
        cells: [
          ...block.cells.slice(0, i),
          [
            ...block.cells[i].slice(0, j),
            {
              ...cell,
              text: action.text,
              validXml: isValidXml(action.text),
            },
            ...block.cells[i].slice(j + 1),
          ],
          ...block.cells.slice(i + 1),
        ],
      };
      return {
        ...state,
        blocks: {
          ...state.blocks,
          [action.blockId]: {
            ...newBlock,
          },
        },
      };
    }
  }
  return state;
};
